module.exports = __webpack_public_path__ + "img/Weapon_26.f362d713.png";